module.exports = __webpack_public_path__ + "img/rubin_benefit_14_community.c8e562e8.svg";